function getShippingCosts(): Record<string, string> {
  return {
    "shipping-001": "0.00",
    "shipping-002": "1.99",
    "shipping-003": "9.99",
    "shipping-munich-001": "4.99",
    "shipping-munich-002": "14.99",
  };
}

export function getShippingOptionsForMunich() {
  return {
    defaultSelectedOptionId: "shipping-munich-001",
    shippingOptions: [
      {
        id: "shipping-munich-001",
        label: "$4.99: Standard shipping",
        description: "Standard shipping delivered in 3 business days.",
      },
      {
        id: "shipping-munich-002",
        label: "$14.99: Express shipping",
        description: "Express shipping delivered in 1 business day.",
      },
    ],
  };
}

export function calculateTotalPrice(displayItems: google.payments.api.DisplayItem[]) {
  return displayItems.reduce((sum, item) => {
    const price = parseFloat(item.price);
    return item.type === "DISCOUNT" ? sum - price : sum + price
  }, 0).toString();
}

export function calculateNewTransactionInfo(
  shippingOptionId: string,
  transactionInfo: google.payments.api.TransactionInfo,
) {
  let newTransactionInfo = transactionInfo;

  // removing the existing shipping info
  newTransactionInfo.displayItems = newTransactionInfo.displayItems?.filter((item) => item.type !== "SHIPPING_OPTION");

  let shippingCost = getShippingCosts()[shippingOptionId];
  newTransactionInfo.displayItems?.push({
    type: "SHIPPING_OPTION",
    label: "Shipping cost",
    price: shippingCost,
  });

  newTransactionInfo.totalPrice = calculateTotalPrice(newTransactionInfo.displayItems ?? []);

  return newTransactionInfo;
}
